<template>
  <div >
    <div class="top-box-two">
      <!---------------------------------------- 白色导航条 ---------------------------------------->
      <div class="index-top">
        <!-- -----------------左侧logo语言切换----------------- -->
        <div class="logo">
          <div><img src="./assets/Logo Shapes 42.png" alt="" /></div>
          <p class="logo-title">{{ $t("effortlessCareer") }}</p>
          <!-- 语言切换 -->
          <div class="change-lang">
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                {{ language }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="0">{{
                  $t("chinese")
                }}</el-dropdown-item>
                <el-dropdown-item command="1">{{
                  $t("japanese")
                }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <!-- ---------------如果登录后展现的top内容--------------- -->
        <div class="login-and-then">
          <button class="job-posting" @click="goToOther">
            {{ $t("homepost") }}
          </button>
          <div class="mask">
            <img :src="urlImgInfo" alt="" />
            <div>{{ itemData.userName }}</div>
          </div>
          <!--          <div class="top-icon-login" @click="goToMes(1)">-->
          <!--            <img src="./assets/bi_chat-left-dots-fill.png" alt="" />-->
          <!--          </div>-->
          <!--          <div class="top-icon-login" @click="goToMes(1)">-->
          <!--            <img src="./assets/ic_round-notifications.png" alt="" />-->
          <!--          </div>-->
        </div>
      </div>
      <!-- ------------------------------------白色导航条结束------------------------------------ -->
      <!-- --------------------------------------蓝色搜索栏-------------------------------------- -->
      <div class="search">
        <div class="search-title">
          <div class="search-title-main">{{ $t("largestStaffing") }}</div>
          <div class="search-main">
            <el-input
              placeholder="医療機関、教育機関、求人案件、人材などをここで検索"
              @input="searchInput"
              v-model="searchData"
              class="search-input"
            >
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <button class="search-button" @click="handleFuzzyMatching">
              {{ $t("search") }}
            </button>
          </div>
          <!--          <img src="./assets/index-img.png" alt="" class="search-img" />-->
        </div>
      </div>
    </div>
    <!-- -----------------------------------蓝色搜索部分结束----------------------------------- -->
    <div class="main-information">
      <!------------------- 主要信息上面类似button提示部分----------------- -->
      <div class="main-top">
        <button
          class="main-top-button-normal"
          :class="
            activeButtonShow ? 'main-top-button-normal' : 'main-top-button-css'
          "
          @click="buttonOneChange"
        >
          {{ $t("medicalInstitution") }}
        </button>
        <button
          :class="
            !activeButtonShow ? 'main-top-button-normal' : 'main-top-button-css'
          "
          @click="buttonTowChange"
        >
          {{ $t("jobOffer") }}
        </button>
      </div>
      <!-- ---------------------------------招聘主要信息展示部分--------------------------------- -->
      <div class="information-main" v-if="RecruitmentIsShow">
        <!-- 左侧 -->
        <div class="seeking-square" v-if="RecruitmentLeftShow">
          <div
            :class="index1 === indexShow ? 'inform-box-active' : 'inform-box'"
            @click="RecruitmentHandleClick(item.medicalId, index1)"
            v-for="(item, index1) in medicalList[0]"
            :key="index1"
          >
            <div class="classification">{{ $t("hospital") }}</div>
            <div class="box-title">
              {{ item.medicalName }}
              <!--               认证标签判断-->
              <!--                <div class="form-button">  <button >{{$t('certified')}}</button>  </div>-->
              <el-button
                class="form-button"
                type="text"
                v-if="item.certifiyStatus == '0'"
              >
                <button>{{ $t("certified") }}</button>
              </el-button>
            </div>
            <p class="company-name">{{ item.address }}</p>
            <p class="company-name">
              {{ $t("registeredCapital")
              }}{{
                language == "CN"
                  ? item.capitalAmount_dictText
                  : item.jpcapitalAmount_dictText
              }}
            </p>
            <p class="company-name">
              {{ $t("numberOfEmployees") }}
              {{
                language == "CN"
                  ? item.employeeNumber_dictText
                  : item.jpemployeeNumber_dictText
              }}
            </p>
            <p class="company-name">
              {{ $t("numberOfBets") }}
              {{
                language == "CN"
                  ? item.bedNumber_dictText
                  : item.jpbedNumber_dictText
              }}
            </p>
            <div class="work-content1">
              {{ item.introduction }}
            </div>
            <p class="last-login2">{{ item.loginDate }}</p>
          </div>
        </div>
        <!-- 右侧 -->
        <div class="seeking-square" v-if="RecruitmentRightShow">
          <div
            :class="index2 === indexShow ? 'inform-box-active' : 'inform-box'"
            @click="rightRecruitmentHandleClick(item.medicalId, index2)"
            v-for="(item, index2) in medicalList[1]"
            :key="index2"
          >
            <div class="classification">{{ $t("hospital") }}</div>
            <div class="box-title">
              <p>{{ item.medicalName }}</p>
              <!--               认证标签判断-->
              <!--                <div class="form-button">  <button >{{$t('certified')}}</button>  </div>-->
              <el-button
                class="form-button"
                type="text"
                v-if="item.certifiyStatus == '0'"
              >
                <button>{{ $t("certified") }}</button>
              </el-button>
            </div>
            <p class="company-name">{{ item.address }}</p>
            <p class="company-name">
              {{ $t("registeredCapital")
              }}{{
                language == "CN"
                  ? item.capitalAmount_dictText
                  : item.jpcapitalAmount_dictText
              }}
            </p>
            <p class="company-name">
              {{ $t("numberOfEmployees") }}
              {{
                language == "CN"
                  ? item.employeeNumber_dictText
                  : item.jpemployeeNumber_dictText
              }}
            </p>
            <p class="company-name">
              {{ $t("numberOfBets") }}
              {{
                language == "CN"
                  ? item.bedNumber_dictText
                  : item.jpbedNumber_dictText
              }}
            </p>
            <div class="work-content1">
              {{ item.introduction }}
            </div>
            <p class="last-login2">{{ item.loginDate }}</p>
          </div>
        </div>
        <!-- 详细信息 -->
        <div class="seeking-square" ref="menu">
          <div
            class="seeking-square"
            v-if="RecruitmentDetailShow"
            :class="headerFixed ? 'issFixed' : ''"
          >
            <div class="detailed-organization">
              <div class="organization-box">
                <!--医疗机构信息-->
                <div @click="handleButton4">
                  <div class="classification">{{ $t("hospital") }}</div>
                  <!-- 第一行带图片的 -->
                  <div class="organization-box-img">
                    <div class="avatar">
                      <img
                        :src="avatarAddressUrl"
                        @error="
                          e => {
                            e.target.src = require('@/assets/defaultImg.png');
                          }
                        "
                        alt=""
                      />
                    </div>
                    <div class="organization-institution-name">
                      <div class="biaoQian">
                        <el-button
                          class="form-button2"
                          type="text"
                          v-if="medicalInstitution.certifiyStatus == '0'"
                        >
                          <button>{{ $t("certified") }}</button>
                        </el-button>
                      </div>
                      <div class="institution-title">
                        <span class="institution-title-main">{{
                          $t("institutionName")
                        }}</span>
                          <el-tooltip :content="medicalInstitution.medicalName">
               <div class="institution-title-tootips">
                        {{ medicalInstitution.medicalName }}
                      </div>
                    </el-tooltip>
                      </div>
                    </div>
                  </div>
                  <!-- 第二行 -->
                  <div class="detail-inline">
                    <div class="inline-box-one">
                      <span class="ps-span">{{ $t("postCode") }}</span>
                      {{ medicalInstitution.postNumber }}
                    </div>
                    <div class="inline-box-two">
                      <span class="ps-span">{{ $t("location") }}</span>
                      {{ medicalInstitution.address }}
                    </div>
                  </div>
                  <!-- 第三行 -->
                  <div class="detail-inline">
                    <div class="inline-box-one">
                      <span class="ps-span">{{
                        $t("institutionalAttributes")
                      }}</span>
                      <div class="inline-box-dropdown">
                        <el-dropdown>
                          <span class="el-dropdown-link">
                            {{ attributes }}
                          </span>
                        </el-dropdown>
                      </div>
                    </div>
                    <div class="inline-box-two">
                      <span class="ps-span">{{ $t("hpOrSns") }}</span>
                      <el-tooltip :content="medicalInstitution.hpOrSns">
                        <div class="inline-box-two-tooltip">
                      {{ medicalInstitution.hpOrSns }}
                    </div>
              </el-tooltip>
                    </div>
                  </div>
                  <!-- 第四行 -->
                  <div class="detail-inline">
                    <div class="inline-box-one">
                      <span class="ps-span">{{
                        $t("representativeName")
                      }}</span>
                        <el-tooltip :content="medicalInstitution.hpOrSns">
                        <div class="inline-box-one-tooltip ">
                    
                      {{ medicalInstitution.legalPerson }}
                    </div>
              </el-tooltip>
                    </div>
                    <div class="inline-box-two">
                      <span class="ps-span">{{
                        $t("institutionalNumber")
                      }}</span>
                      {{ medicalInstitution.telephone }}
                    </div>
                  </div>
                  <!-- 第五行 -->
                  <div class="detail-inline">
                    <div class="inline-box-one inline-box-one-margin">
                      <span class="ps-span">{{ $t("registeredCapital") }}</span>
                      <div class="inline-box-dropdown">
                        <el-dropdown>
                          <span class="el-dropdown-link">
                            {{ capitalAmount }}
                          </span>
                        </el-dropdown>
                      </div>
                    </div>
                    <div class="inline-box-three inline-box-three-margin">
                      <span class="ps-span">{{ $t("numberOfEmployees") }}</span>
                      <div class="inline-box-dropdown1">
                        <el-dropdown>
                          <span class="el-dropdown-link">
                            {{
                              language === "CN"
                                ? medicalInstitution.employeeNumber_dictText
                                : medicalInstitution.jpemployeeNumber_dictText
                            }}
                          </span>
                        </el-dropdown>
                      </div>
                    </div>
                    <div class="inline-box-three inline-box-three-margin">
                      <span class="ps-span">{{ $t("numberOfBets") }}</span>
                      <div class="inline-box-dropdown1">
                        <el-dropdown>
                          <span class="el-dropdown-link">
                            {{ bedNumber }}
                          </span>
                        </el-dropdown>
                      </div>
                    </div>
                  </div>

                  <!-- 第六行 -->
                  <div class="detail-inline1">
                    <p class="inline-detail-shi">{{ $t("businessContent") }}</p>
                    <p class="inline-detail-ye">
                      {{ medicalInstitution.introduction }}
                    </p>
                  </div>
                </div>
                <!-- table部分 -->
                <div class="inline-table">
                  <el-table
                    :data="tableData"
                    style="width: 100%"
                    @row-click="jump"
                    :min-height="150"
                  >
                    <el-table-column type="selection" width="55">
                    </el-table-column>
                    <el-table-column
                      prop="jobName"
                      label="案件名"
                      width="80"
                      :show-overflow-tooltip="true"
                    >
                      <template slot="header">
                        <p>{{ $t("projectTitle") }}</p>
                        <el-input
                          v-model="search1"
                          size="mini"
                          placeholder="Search"
                          class="table-input"
                        />
                      </template>
                      <template slot-scope="scope">
                        {{ scope.row.jobName }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="workSpace"
                      label="勤務地"
                      width="80"
                      :show-overflow-tooltip="true"
                    >
                      <template slot="header">
                        <p>{{ $t("workLocation") }}</p>
                        <el-input
                          v-model="search2"
                          size="mini"
                          placeholder="Search"
                          class="table-input"
                        />
                      </template>
                      <template slot-scope="scope">
                        {{ scope.row.workSpace }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="createTime"
                      label="掲載日"
                      width="100"
                      :show-overflow-tooltip="true"
                    >
                      <template slot="header">
                        <p>{{ $t("payonTheDay") }}</p>
                        <el-input
                          v-model="search3"
                          size="mini"
                          placeholder="Search"
                          class="table-input"
                        />
                      </template>
                      <template slot-scope="scope">
                        {{ scope.row.createTime }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="visitedTime"
                      label="観覧回数 "
                      :sortable="'custom'"
                      width="110"
                      :show-overflow-tooltip="true"
                    >
                      <template slot="header">
                        <p>{{ $t("viewingTimes") }}</p>
                        <el-dropdown>
                          <span class="el-dropdown-link">
                            All<i class="el-icon-arrow-down el-icon--right"></i>
                          </span>
                        </el-dropdown>
                      </template>
                      <template slot-scope="scope">
                        {{ scope.row.visitedTime }}
                      </template>
                    </el-table-column>
                  </el-table>
                  <!-- 分页部分 -->
                  <div class="pagination-css">
                    <el-pagination
                      layout="prev, pager, next, sizes"
                      :total="total"
                      :page-sizes="[5, 10, 15, 20]"
                      :current-page="currentPage"
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"
                      class="pagination"
                    >
                    </el-pagination>
                  </div>
                </div>

                <div class="display-none-css" @click="noBoxHandleIsShow">
                  <img src="./assets/Arrow_Right_LG.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- ---------------------------------人才主要信息展示部分--------------------------------- -->
      <div class="information-main" v-if="talentIsShow">
        <!-- --------------左侧-------------- -->
        <div class="seeking-square" v-if="talentLeftShow">
          <!--求人広場box  -->
          <div
            :class="index3 === indexShow2 ? 'inform-box-active' : 'inform-box'"
            @click="talentHandleClick(item.jobId, index3)"
            v-for="(item, index3) in jobList[0]"
            :key="index3"
          >
            <div class="classification">
              {{ $t("nursing") }}・{{ $t("rehabilitation") }}
            </div>
            <div class="box-title">
              {{ item.jobName }}
            </div>
            <p class="company-name">{{ item.medicalName }}）</p>
            <p class="company-name">{{ item.workSpace }}</p>
            <div class="box-mini">
              <div class="mini-box-main" v-if="item.label1 === '1'">
                {{
                  language === "CN"
                    ? item.label1_dictText
                    : item.jplabel1_dictText
                }}
              </div>
              <div class="mini-box-main" v-if="item.label2 === '1'">
                {{
                  language === "CN"
                    ? item.label2_dictText
                    : item.jplabel2_dictText
                }}
              </div>
              <div class="mini-box-main" v-if="item.label3 === '1'">
                {{
                  language === "CN"
                    ? item.label3_dictText
                    : item.jplabel3_dictText
                }}
              </div>
              <div class="mini-box-main" v-if="item.label4 === '1'">
                {{
                  language === "CN"
                    ? item.label4_dictText
                    : item.jplabel4_dictText
                }}
              </div>
            </div>
            <p class="company-name">
              {{
                language === "CN"
                  ? item.hourSalary_dictText
                  : item.jphourSalary_dictText
              }}{{ item.startSalary}}~{{ item.endSalary }}
            </p>
            <p class="company-name ">
              <span v-if="item.employmentForm1 === '1'">{{
                language === "CN"
                  ? item.employmentForm1_dictText
                  : item.jpemploymentForm1_dictText
              }}</span>
              <span v-if="item.employmentForm2 === '1'">{{
                language === "CN"
                  ? item.employmentForm2_dictText
                  : item.jpemploymentForm2_dictText
              }}</span>
              <span v-if="item.employmentForm3 === '1'">{{
                language === "CN"
                  ? item.employmentForm3_dictText
                  : item.jpemploymentForm3_dictText
              }}</span>
              <span v-if="item.employmentForm4 === '1'">{{
                language === "CN"
                  ? item.employmentForm4_dictText
                  : item.jpemploymentForm4_dictText
              }}</span>
            </p>
           



            <div class="work-content">
              {{ $t("workContent") }}：{{ item.workContent }}
            </div>
            <p class="last-login">{{ item.loginDate }}</p>
          </div>
          <!-- box over -->
        </div>
        <!-- --------------右侧-------------- -->
        <div class="seeking-square" v-if="talentRightShow">
          <!--求人広場box  -->
          <div
            :class="index4 === indexShow2 ? 'inform-box-active' : 'inform-box'"
            @click="rightTalentHandleClick(item.jobId, index4)"
            v-for="(item, index4) in jobList[1]"
            :key="index4"
          >
            <div class="classification">
              {{ $t("nursing") }}・{{ $t("rehabilitation") }}
            </div>
            <div class="box-title">
              {{ item.jobName }}
            </div>
            <p class="company-name">{{ item.medicalName }}</p>
            <p class="company-name">{{ item.workSpace }}</p>
            <div class="box-mini">
              <div class="mini-box-main" v-if="item.label1 === '1'">
                {{
                  language === "CN"
                    ? item.label1_dictText
                    : item.jplabel1_dictText
                }}
              </div>
              <div class="mini-box-main" v-if="item.label2 === '1'">
                {{
                  language === "CN"
                    ? item.label2_dictText
                    : item.jplabel2_dictText
                }}
              </div>
              <div class="mini-box-main" v-if="item.label3 === '1'">
                {{
                  language === "CN"
                    ? item.label3_dictText
                    : item.jplabel3_dictText
                }}
              </div>
              <div class="mini-box-main" v-if="item.label4 === '1'">
                {{
                  language === "CN"
                    ? item.label4_dictText
                    : item.jplabel4_dictText
                }}
              </div>
            </div>
            <p class="company-name">
              {{
                language === "CN"
                  ? item.hourSalary_dictText
                  : item.jphourSalary_dictText
              }}{{ item.startSalary }}~{{ item.endSalary }}
            </p>
            <p class="company-name">
              <span v-if="item.employmentForm1 === '1'">{{
                language === "CN"
                  ? item.employmentForm1_dictText
                  : item.jpemploymentForm1_dictText
              }}</span>
              <span v-if="item.employmentForm2 === '1'">{{
                language === "CN"
                  ? item.employmentForm2_dictText
                  : item.jpemploymentForm2_dictText
              }}</span>
              <span v-if="item.employmentForm3 === '1'">{{
                language === "CN"
                  ? item.employmentForm3_dictText
                  : item.jpemploymentForm3_dictText
              }}</span>
              <span v-if="item.employmentForm4 === '1'">{{
                language === "CN"
                  ? item.employmentForm4_dictText
                  : item.jpemploymentForm4_dictText
              }}</span>
            </p>
            <div class="work-content">
              {{ $t("workContent") }}：{{ item.workContent }}
            </div>
            <p class="last-login">{{ item.loginDate }}</p>
          </div>
          <!-- box over -->
        </div>
        <!-- --------------右侧案件详细信息-------------- -->
        <div class="seeking-square" ref="menu">
          <div
            class="seeking-square"
            v-if="talentDetailShow"
            :class="headerFixed ? 'issFixed' : ''"
          >
            <!-- 详细信息box开始 -->
            <div class="recruitment-box-main">
              <div @click="handleButton3">
                <div class="recruitment-title">
                  {{ $t("nursing") }}・{{ $t("rehabilitation") }}
                </div>
                <div class="recruitment-box-title">
                  {{ jobOfferInfo.jobName }}
                </div>
                <p class="company-name">{{ jobOfferInfo.medicalName }}</p>
                <p class="company-name">{{ jobOfferInfo.workSpace }}</p>
                <div class="box-mini">
                  <div class="mini-box-main" v-if="jobOfferInfo.label1 === '1'">
                    {{
                      language === "CN"
                        ? jobOfferInfo.label1_dictText
                        : jobOfferInfo.jplabel1_dictText
                    }}
                  </div>
                  <div class="mini-box-main" v-if="jobOfferInfo.label2 === '1'">
                    {{
                      language === "CN"
                        ? jobOfferInfo.label2_dictText
                        : jobOfferInfo.jplabel2_dictText
                    }}
                  </div>
                  <div class="mini-box-main" v-if="jobOfferInfo.label3 === '1'">
                    {{
                      language === "CN"
                        ? jobOfferInfo.label3_dictText
                        : jobOfferInfo.jplabel3_dictText
                    }}
                  </div>
                  <div class="mini-box-main" v-if="jobOfferInfo.label4 === '1'">
                    {{
                      language === "CN"
                        ? jobOfferInfo.label4_dictText
                        : jobOfferInfo.jplabel4_dictText
                    }}
                  </div>
                </div>
                <p class="company-name">
                  {{
                    language === "CN"
                      ? jobOfferInfo.hourSalary_dictText
                      : jobOfferInfo.jphourSalary_dictText
                  }}
                  {{ jobOfferInfo.startSalary }}~{{ jobOfferInfo.endSalary }}
                </p>
              </div>
              <div class="recruitment-box-button">
                <button
                  class="button1"
                  @click="
                    handleButton1(
                      jobOfferInfo.jobId,
                      jobOfferInfo.jobName,
                      jobOfferInfo.userName,
                      jobOfferInfo.medicalName
                    )
                  "
                >
                  {{ $t("apply") }}
                </button>
                <button
                  class="button2"
                  @click="handleButton2(jobOfferInfo.jobId)"
                >
                  {{ $t("collection") }}
                </button>
                <button class="button2" @click="handleButton3">
                  {{ $t("talk") }}
                </button>
              </div>

              <!-- 滚动部分 -->
              <div class="mask-recruitment" @click="handleButton3">
                <!-- 滚动具体内容 -->
                <div class="recruitment-main-scroll">
                  <div class="recruitment-scroll-img">
                    <img :src="imgList[0]" alt="" />
                    <img :src="imgList[1]" alt="" />
                    <img :src="imgList[2]" alt="" />
                  </div>
                  <!-- 标签 -->
                  <div class="box-introduce">
                    <div
                      class="box-introduce-main"
                      v-if="jobOfferInfo.employmentForm1 === '1'"
                    >
                      {{ $t("fullTimeEmployee") }}
                    </div>
                    <div
                      class="box-introduce-main"
                      v-if="jobOfferInfo.employmentForm2 === '1'"
                    >
                      {{ $t("partTimeJob") }}
                    </div>
                    <div
                      class="box-introduce-main"
                      v-if="jobOfferInfo.employmentForm3 === '1'"
                    >
                      {{ $t("specificSkill") }}
                    </div>
                    <div
                      class="box-introduce-main"
                      v-if="jobOfferInfo.employmentForm4 === '1'"
                    >
                      {{ $t("technicalInternTrainee") }}
                    </div>
                  </div>
                  <!-- 具体内容 -->
                  <div class="specific-contents">
                    <!---------------------- 每一行-------------------- -->
                    <div class="specific-main-box">
                      <div class="specific-main-top">
                        {{ $t("occupationCategory") }}
                      </div>
                      <!--                              <div class="specific-main-top-title" v-if="jobOfferInfo.length !== 0">{{-->
                      <!--                                  jobOfferInfo.workType-->
                      <!--                                }}-->
                      <!--                              </div>-->
                      <div
                        class="specific-main-top-title"
                        v-if="language === 'CN'"
                      >
                        {{ jobOfferInfo.workType_dictText }}
                      </div>
                      <div
                        class="specific-main-top-title"
                        v-if="language === 'JP'"
                      >
                        {{ jobOfferInfo.jpworkType_dictText }}
                      </div>
                    </div>
                    <!-- --------------------每一行结束-------------------- -->
                    <!---------------------- 每一行-------------------- -->
                    <div class="specific-main">
                      <!-- 左边 -->
                      <div class="specific-main-box">
                        <div class="specific-main-top">
                          {{ $t("employmentForm") }}
                        </div>
                        <el-tooltip
                                 :content="(jobOfferInfo.employmentForm1 === '1'?(language === 'CN'? jobOfferInfo.employmentForm1_dictText: jobOfferInfo.jpemploymentForm1_dictText):'')
                             +'  '   +(jobOfferInfo.employmentForm2 ==='1'?(language === 'CN'? jobOfferInfo.employmentForm2_dictText: jobOfferInfo.jpemploymentForm2_dictText):'')
                             +'  '    +(jobOfferInfo.employmentForm3 === '1'?(language === 'CN'? jobOfferInfo.employmentForm3_dictText: jobOfferInfo.jpemploymentForm3_dictText):'')
                             +'  '    +(jobOfferInfo.employmentForm4 === '1'?(language === 'CN'? jobOfferInfo.employmentForm4_dictText: jobOfferInfo.jpemploymentForm4_dictText):'')
                                "
                                placement="top">
                        <div class="specific-main-top-title tooltip-content">
                          <span v-if="jobOfferInfo.employmentForm1 === '1'">{{
                            language === "CN"
                              ? jobOfferInfo.employmentForm1_dictText
                              : jobOfferInfo.jpemploymentForm1_dictText
                          }}</span>
                          <span v-if="jobOfferInfo.employmentForm2 === '1'">{{
                            language === "CN"
                              ? jobOfferInfo.employmentForm2_dictText
                              : jobOfferInfo.jpemploymentForm2_dictText
                          }}</span>
                          <span v-if="jobOfferInfo.employmentForm3 === '1'">{{
                            language === "CN"
                              ? jobOfferInfo.employmentForm3_dictText
                              : jobOfferInfo.jpemploymentForm3_dictText
                          }}</span>
                          <span v-if="jobOfferInfo.employmentForm4 === '1'">{{
                            language === "CN"
                              ? jobOfferInfo.employmentForm4_dictText
                              : jobOfferInfo.jpemploymentForm4_dictText
                          }}</span>
                        </div>
                        </el-tooltip>
                      </div>
                      <!-- 右边 -->
                      <div class="specific-main-box">
                        <div class="specific-main-top">
                          {{ $t("dutyTime") }}
                        </div>
                        <div class="specific-main-top-title">
                          {{ jobOfferInfo.workTime }}
                        </div>
                      </div>
                    </div>
                    <!-- --------------------每一行结束-------------------- -->
                    <!---------------------- 每一行-------------------- -->
                    <div class="specific-main">
                      <!-- 左边 -->
                      <div class="specific-main-box">
                        <div class="specific-main-top">{{ $t("salary") }}</div>
                        <div class="specific-main-top-title">
                         <span 
                            >{{ jobOfferInfo.startSalary }}~{{
                              jobOfferInfo.endSalary
                            }}</span
                          >
                        </div>
                      </div>
                      <!-- 右边 -->
                      <div class="specific-main-box">
                        <div class="specific-main-top">
                          {{ $t("numberOfHires") }}
                        </div>
                        <div class="specific-main-top-title">
                          {{ jobOfferInfo.recruitNumber }}名
                        </div>
                      </div>
                    </div>
                    <!-- --------------------每一行结束-------------------- -->
                    <!---------------------- 每一行-------------------- -->
                    <div class="specific-main">
                      <!-- 左边 -->
                      <div class="specific-main-box">
                        <div class="specific-main-top">
                          {{ $t("recruiter") }}
                        </div>
                        <div class="specific-main-top-title">
                          {{ jobOfferInfo.userName }}
                        </div>
                      </div>
                      <!-- 右边 -->
                      <div class="specific-main-box">
                        <div class="specific-main-top">
                          {{ $t("targetRecruitmentTime") }}
                        </div>
                        <div class="specific-main-top-title">
                          {{ jobOfferInfo.principalTime }}
                        </div>
                      </div>
                    </div>
                    <!-- --------------------每一行结束-------------------- -->
                    <!-- 每一长行开始 -->
                    <div class="specific-main-long">
                      <div class="long-box">
                        <div class="long-box-title">
                          {{ $t("workContent") }}
                        </div>
                        <div class="long-box-main">
                          {{ jobOfferInfo.workContent }}
                        </div>
                      </div>
                    </div>
                    <!-- 每一长行结束 -->
                    <!-- 每一长行开始 -->
                    <div class="specific-main-long">
                      <div class="long-box">
                        <div class="long-box-title">{{ $t("welfare") }}</div>
                        <div class="long-box-main">
                          {{ jobOfferInfo.welfareTreatment }}
                        </div>
                      </div>
                    </div>
                    <!-- 每一长行结束 -->
                    <!-- 每一长行开始 -->
                    <div class="specific-main-long">
                      <div class="long-box">
                        <div class="long-box-title">
                          {{ $t("employmentConditions") }}
                        </div>
                        <div class="long-box-main">
                          {{ jobOfferInfo.employmentConditions }}
                        </div>
                      </div>
                    </div>
                    <!-- 每一长行结束 -->
                    <!-- 每一长行开始 -->
                    <div class="specific-main-long">
                      <div class="long-box">
                        <div class="long-box-title">{{ $t("other") }}</div>
                        <div class="long-box-main">
                          {{ jobOfferInfo.other }}
                        </div>
                      </div>
                    </div>
                    <!-- 每一长行结束 -->
                  </div>
                </div>
                <!-- 滚动具体内容结束 -->
              </div>
              <!-- 滚动部分结束 -->
              <!-- 返回按键 -->
              <div class="disappear-box" @click="noBoxIsShow">
                <img src="./assets/Arrow_Right_LG.png" alt="" />
              </div>
            </div>
            <!-- 详细信息box结束 -->
          </div>
        </div>
      </div>
    </div>

    <div class="search-dialog" v-if="searchShow">
      <div class="dialog-main">
        <p class="box">{{ $t("noResults") }}</p>
        <button class="dialog-button" @click="close">
          {{ $t("close") }}
        </button>
      </div>
    </div>
    <div class="el-icon-loading-icon" v-if="iconLoadingIsShow">
      <i class="el-icon-loading" style="margin-right: 10px;"></i
      >{{ $t("loadingWord") }}
    </div>
    <div class="el-icon-loading-icon" v-if="moreDataShow">
      {{ $t("noMoreData") }}
    </div>
  </div>
</template>
<script>
import {
  findPersonCaseDetailsQuery,
  findPersonCaseListQuery,
  fuzzyCaseAndMedicalQuery,
  medicalInstitutionDetailsQuery,
  medicalInstitutionListQuery,
  getUrlFromOSS,
  insertMedicalCollection,
  addEducationCollect
} from "../../js/api";
import AES from "../../js/AES";

export default {
  name: "loginFront",
  components: {},
  data() {
    return {
      lang: "JP",
      searchData: "", //搜索框
      activeButtonShow: true, //button标识
      RecruitmentIsShow: true, //医疗标识
      RecruitmentLeftShow: true, //医疗左边标识
      RecruitmentRightShow: true, //医疗右边标识
      RecruitmentDetailShow: false, //医疗详细信息
      talentIsShow: false, //招聘标识
      talentLeftShow: true, //招聘左边标识
      talentRightShow: true, //招聘右边标识
      talentDetailShow: false, //招聘详情标识
      dropdownOne: "", //机关属性的下拉显示
      dropdownTwo: "", //資本金的下拉显示
      dropdownThree: "", //職員数的下拉显示
      dropdownFour: "", //ベット数的下拉显示
      search1: "",
      search2: "",
      search3: "",
      search4: "",
      itemData: {},
      jobId: "",
      medicalId: "",
      medicalList: [], //医疗机构列表
      jobList: [], //求人案件列表
      medicalList2: [], //医疗机构列表
      jobList2: [], //求人案件列表
      caseList: [], //案件信息
      medicalInstitution: [], //医疗机构信息
      jobOfferInfo: [], //求人案件详情
      tableData: [], //详情table
      urlImgInfo: "",
      medicalListData: [],
      jobListData: [],
      currentPage: 1, //页数
      pageSize: 10, //每页条数
      avatarAddressUrl: "",
      imgList: [],
      total: 50,
      offsetTop: 0,
      offsetHeight: 0,
      headerFixed: 0,
      resultData: [],
      indexShow: "",
      indexShow2: "",
      attributes: "",
      capitalAmount: "",
      bedNumber: "",
      language: "",
      auto: "",
      searchShow: false,
      listCurrentPage: 1,
      listPageSize: 8,
      iconLoadingIsShow: false,
      label1: 0,
      label2: 0,
      label3: 0,
      label4: 0,
      label5: 0,
      label6: 0,
      label7: 0,
      label8: 0,
      moreDataShow: false
    };
  },
  created() {
    //获取当前语言的值
    this.language = window.localStorage.getItem("language");
    console.log("语言选择为" + window.localStorage.getItem("language"));
    console.log("页面语言选择为" + this.language);
    //获取数据字典语言值方法
    this.getLanguage();
    this.getAES();
    //查询求人案件信息(列表)接口
    this.handleFindPersonCaseListQuery();
    //医疗机构信息查询(列表)
    this.handleMedicalInstitutionListQuery();
  },
  mounted() {
    this.$nextTick(() => {
      const menu = this.$refs.menu;
      // 吸顶元素到top的距离
      this.offsetTop = menu.offsetTop;
      // 元素自身的高度
      this.offsetHeight = menu.offsetHeight;
      // 监听滚动条
      window.addEventListener("scroll", this.handleScroll);
    });
    window.addEventListener("scroll", this.handleScroll2, true);
    window.addEventListener("setItemEvent", this.languageChange, true);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("scroll", this.handleScroll2, true);
    window.removeEventListener("setItemEvent", this.languageChange, true);
  },

  computed: {},
  methods: {
    searchInput(e) {
      if (e === "") {
        this.listCurrentPage = 1;
        this.listPageSize = 8;
        this.handleMedicalInstitutionListQuery();

        this.handleFindPersonCaseListQuery();
      }
    },
    languageChange(e) {
      const that = this;
      console.log("------监听数据------");
      console.log(e);
      if (e.key && e.key == "language" && e.newValue) {
        that.language = e.newValue;
        //获取数据字典语言值方法
        that.getLanguage();
        that.getAES();
        //查询求人案件信息(列表)接口
        that.handleFindPersonCaseListQuery();
        //医疗机构信息查询(列表)
        that.handleMedicalInstitutionListQuery();
      }
    },
    close() {
      this.searchShow = false;
    },
    //判断 是否到底部
    handleScroll2() {
      let scrollTop2 =
        document.documentElement.scrollTop || document.body.scrollTop; // 变量windowHeight是可视区的高度
      let windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight; // 变量scrollHeight是滚动条的总高度
      let scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      //   console.log("scrollTop2, windowHeight, scrollHeight")
      if (scrollTop2 + windowHeight >= scrollHeight) {
        this.iconLoadingIsShow = true;
        this.listPageSize = this.listPageSize + 4;
        if (this.searchData === ""&&!this.moreDataShow) {
          if (this.RecruitmentIsShow === true) {
            this.handleMedicalInstitutionListQuery();
          } else {
            this.handleFindPersonCaseListQuery();
          }
        }
        return false;
      }

      if (scrollTop2 >= 500) {
        this.iconLoadingIsShow = true;
      } else if (scrollTop2 < 500) {
        this.moreDataShow = false;
        this.iconLoadingIsShow = false; //小于480时隐藏元素
      }
    },
    //获得语言
    getLanguage() {
      if (this.language === "CN") {
        this.capitalAmount = this.medicalInstitution.capitalAmount_dictText;
        this.attributes = this.medicalInstitution.attributes_dictText;
        this.bedNumber = this.medicalInstitution.bedNumber_dictText;
      } else {
        this.capitalAmount = this.medicalInstitution.jpcapitalAmount_dictText;
        this.attributes = this.medicalInstitution.jpattributes_dictText;
        this.bedNumber = this.medicalInstitution.jpbedNumber_dictText;
      }
    },
    handleScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.headerFixed = scrollTop > this.offsetTop - this.offsetHeight && (this.medicalListData.length > 1 || this.jobListData.length > 1);
    },
  
    //消息跳转
    goToMes(item) {
      this.$router.push("/educationInstitutionNewsView");
    },
    //top 跳转
    goToOther() {
      if (this.itemData.roleName === "educationalinstitutionadmin") {
        this.$router.push("/educationalInstitutionTalentListView");
      } else {
        this.$router.push("/userEducationalInstitutionTalentListView");
      }
    },
    // 获取头部信息
    getAES() {
      var userInfo = localStorage.getItem("userInfo");
      const aesFecInfo = JSON.parse(AES.decrypt(userInfo));
      console.log("---------------userInfo---------------");
      console.log(aesFecInfo);
      this.itemData = aesFecInfo;
      this.getUrl();
    },
    // 头像回显
    getUrl() {
      var fakeInfo = {
        message: this.itemData.avatar
      };
      getUrlFromOSS(fakeInfo)
        .then(res => {
          console.log("-----------头像回显-----------");
          if (res.data.code === "200 OK") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.urlImgInfo = aesFecInfo.message;
          }
          console.log(res);
        })
        .catch(res => {
          console.log("-----------头像回显-----------");
          console.log(res);
        });
    },
    getjobOfferInfoUrl(url) {
      this.imgList = [];
      var fakeInfo = {
        message: url
      };
      getUrlFromOSS(fakeInfo)
        .then(res => {
          if (res.data.code === "200 OK") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            // console.log(aesFecInfo);
            this.imgList.push(aesFecInfo.message);
          }
        })
        .catch(() => {});
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getMedicalInstitutionDetailsQuery(this.medicalId);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getMedicalInstitutionDetailsQuery(this.medicalId);
    },

    //button 1 点击
    buttonOneChange() {
      this.activeButtonShow = true;
      this.RecruitmentIsShow = true;
      this.moreDataShow = false;
      this.talentIsShow = false;
      this.talentLeftShow = true;
      this.talentRightShow = true;
      this.talentDetailShow = false;
      this.judgeSearch();
      this.listPageSize = 4;
    },
    //button 2 点击
    buttonTowChange() {
      this.activeButtonShow = false;
      this.RecruitmentIsShow = false;
      this.moreDataShow = false;
      this.talentIsShow = true;
      this.talentLeftShow = true;
      this.talentRightShow = true;
      this.talentDetailShow = false;
      this.judgeSearch();
      this.listPageSize = 4;
    },
    //医疗机构左边box点击
    RecruitmentHandleClick(res, index1) {
      this.RecruitmentLeftShow = true;
      this.RecruitmentRightShow = false;
      this.RecruitmentDetailShow = true;
      this.medicalList[0] = this.medicalListData;
      this.getMedicalInstitutionDetailsQuery(res);
      this.medicalId = res;
      this.indexShow = index1;
      // console.log("点击左侧")
      // console.log("data"+this.medicalListData)
      // console.log("list"+this.medicalList)
    },
    //医疗机构右边box点击
    rightRecruitmentHandleClick(res, index2) {
      this.RecruitmentLeftShow = false;
      this.RecruitmentRightShow = true;
      this.RecruitmentDetailShow = true;
      this.medicalList[0] = this.medicalListData;
      this.getMedicalInstitutionDetailsQuery(res);
      this.medicalId = res;
      this.indexShow = index2;
      // console.log("点击右侧")
      // console.log("data"+this.medicalListData)
      // console.log("list"+this.medicalList)
    },
    //医疗机构详细信息返回
    noBoxHandleIsShow() {
      this.RecruitmentLeftShow = true;
      this.RecruitmentRightShow = true;
      this.RecruitmentDetailShow = false;
      this.indexShow = "";
      this.medicalList = this.handleAverage(this.medicalListData);
    },
    //求人左边box点击
    talentHandleClick(res, index3) {
      this.talentLeftShow = true;
      this.talentRightShow = false;
      this.talentDetailShow = true;
      this.getFindPersonCaseDetailsQuery(res);
      this.jobList[0] = this.jobListData;
    
      this.indexShow2 = index3;
    },
    //求人右边box点击
    rightTalentHandleClick(res, index4) {
      this.talentLeftShow = false;
      this.talentRightShow = true;
      this.talentDetailShow = true;
      this.getFindPersonCaseDetailsQuery(res);
      this.jobList[0] = this.jobListData;
    
      this.indexShow2 = index4;
    },
    //noBoxIsShow 返回正常页面
    noBoxIsShow() {
      this.talentLeftShow = true;
      this.talentRightShow = true;
      this.talentDetailShow = false;
      this.indexShow2 = "";
      this.jobList = this.handleAverage(this.jobListData);
    },
    //7-4
    handleButton1(jobId, jobName, userName, medicalName) {
      this.$router.push({
        path: "/educationalInstitutionAddRecruiter",
        name: "educationalInstitutionAddRecruiter",
        params: {
          jobId: jobId,
          jobName: jobName,
          userName: jobName,
          medicalName: medicalName
        }
      });
    },
    //13-2
    handleButton2(jobId) {
      var educationCollectAddDTO = {
        systemEventId: jobId,
        systemTypeId: 4
      };
      addEducationCollect(educationCollectAddDTO)
        .then(res => {
          console.log("教育机构添加收藏", res);
          if (res.data.code === "A0000") {
            this.$message({
              message: this.$t("collectionSuccess"),
              type: "success"
            });
            this.$router.push({
              path: "/educationalInstitutionCaseCollectionList",
              name: "educationalInstitutionCaseCollectionList",
              params: {}
            });
          } else if (res.data.code === "A0506") {
            this.$message({
              message: this.$t("thisApplicationFavorite"),
              type: "warning"
            });
          } else {
            this.$message.error(this.$t("submitABug"));
          }
        })
        .catch(res => {
          console.log("教育机构添加收藏接口异常", res);
        });
    },
    //6-3
    handleButton3() {
      this.$router.push({
        path: "/educationViewJobInformation",
        name: "educationViewJobInformation",
        query: {
          id: this.jobOfferInfo.jobId
        }
      });
    },
    //(5-4)教育机关视角下 查看医疗机关主页
    handleButton4() {
      this.$router.push({
        path: "/educationViewMedicalHomepage",
        name: "educationViewMedicalHomepage",
        params: {
          medicalId: this.medicalInstitution.medicalId
        }
      });
      console.log(this.medicalInstitution.medicalId);
    },
    //6-3
    jump(row, event, column) {
      this.$router.push({
        path: "/educationViewJobInformation",
        name: "educationViewJobInformation",
        query: {
          id: row.jobId,
          medicalId: this.medicalId
        }
      });
    },
    //切换语言
    handleCommand(command) {
      if (command === "0") {
        this.$i18n.locale = "zh-CN";
        this.lang = "CN";
        this.language = "CN";
        localStorage.setItem("language", this.lang);
      } else {
        this.$i18n.locale = "ja-JP";
        this.lang = "JP";
        this.language = "JP";
        localStorage.setItem("language", this.lang);
      }
    },
    //教育机构收藏

    //模糊匹配案件信息和医疗机构信息接口
    handleFuzzyMatching() {
      var dto = {
        queryCriteria: this.searchData,
        pageNumber: this.listCurrentPage,
        pageSize: this.listPageSize
      };
      fuzzyCaseAndMedicalQuery(dto)
        .then(res => {
          console.log("--------模糊匹配案件信息和医疗机构信息接口数据--------");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.medicalListData = [];
            this.jobListData = [];
            this.medicalListData = aesFecInfo.data2;
            this.jobListData = aesFecInfo.data1;
            this.medicalList = this.handleAverage(this.medicalListData); //医疗
            this.jobList = this.handleAverage(this.jobListData); //求人案件
            //首次判空
            if (this.RecruitmentIsShow === true) {
              if (
                this.medicalListData.length === 0 &&
                this.jobListData.length === 0
              ) {
                this.searchShow = true;
              } else if (
                this.medicalListData.length === 0 &&
                this.jobListData.length !== 0
              ) {
                this.activeButtonShow = false;
                this.talentIsShow = true;
                this.RecruitmentIsShow = false;
                this.searchShow = false;
              } else if (
                this.medicalListData.length !== 0 &&
                this.jobListData.length === 0
              ) {
                this.searchShow = false;
              } else {
                this.searchShow = false;
              }
            } else if (this.talentIsShow === true) {
              if (
                this.medicalListData.length === 0 &&
                this.jobListData.length === 0
              ) {
                this.searchShow = true;
              } else if (
                this.medicalListData.length === 0 &&
                this.jobListData.length !== 0
              ) {
                this.searchShow = false;
              } else if (
                this.medicalListData.length !== 0 &&
                this.jobListData.length === 0
              ) {
                this.activeButtonShow = true;
                this.RecruitmentIsShow = true;
                this.talentIsShow = false;
                this.searchShow = false;
              } else {
                this.searchShow = false;
              }
            }
          }
        })
        .catch(res => {
          console.log("模糊匹配案件信息和医疗机构信息接口数据异常:", res);
        });
    },
    judgeSearch() {
      if (this.RecruitmentIsShow === true) {
        if (
          this.medicalListData.length === 0 &&
          this.jobListData.length === 0
        ) {
          this.searchShow = true;
        } else if (
          this.medicalListData.length === 0 &&
          this.jobListData.length !== 0
        ) {
          this.searchShow = true;
        } else if (
          this.medicalListData.length !== 0 &&
          this.jobListData.length === 0
        ) {
          this.searchShow = false;
        } else {
          this.searchShow = false;
        }
      } else if (this.talentIsShow === true) {
        if (
          this.medicalListData.length === 0 &&
          this.jobListData.length === 0
        ) {
          this.searchShow = true;
        } else if (
          this.medicalListData.length === 0 &&
          this.jobListData.length !== 0
        ) {
          this.searchShow = false;
        } else if (
          this.medicalListData.length !== 0 &&
          this.jobListData.length === 0
        ) {
          this.searchShow = true;
        } else {
          this.searchShow = false;
        }
      }
    },
    //数组拆分
    handleAverage(evt) {
      this.resultData = [];
      for (let i = 0; i < evt.length; i += Math.ceil(evt.length / 2)) {
        this.resultData.push(evt.slice(i, i + Math.ceil(evt.length / 2)));
      }
      return this.resultData;
    },
    //查询求人案件信息(列表)接口
    handleFindPersonCaseListQuery() {
      var pageDTO = {
        pageNumber: this.listCurrentPage,
        pageSize: this.listPageSize
      };
      findPersonCaseListQuery(pageDTO)
        .then(res => {
          console.log("--------查询求人案件信息(列表)接口数据--------");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            
            this.jobListData = aesFecInfo.data;
            if (aesFecInfo.data.length === aesFecInfo.total) {
              this.moreDataShow = true;
            }
            if (aesFecInfo.data.length > 0) {
              this.searchShow = false;
            }
          
          // if(this.talentDetailShow===false){
              this.jobList = this.handleAverage(this.jobListData);
              if(this.talentDetailShow===true){
              this.jobList[0] =this.jobListData 
              this.jobList[1] =this.jobListData 
          }
       
            // }
          }
        })
        .catch(res => {
          console.log("查询求人案件信息(列表)接口数据异常:", res);
        });
    },

    ////医疗机构信息查询(列表)
    handleMedicalInstitutionListQuery() {
      var pageDTO = {
        pageNumber: this.listCurrentPage,
        pageSize: this.listPageSize
      };
      medicalInstitutionListQuery(pageDTO)
        .then(res => {
          console.log("--------医疗机构信息查询(列表)接口数据--------");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            if (aesFecInfo.data.length === aesFecInfo.total) {
              this.moreDataShow = true;
            }
            if (aesFecInfo.data.length > 0) {
              this.searchShow = false;
            }
            this.medicalListData = aesFecInfo.data;
            this.medicalList = this.handleAverage(this.medicalListData);
            if(this.RecruitmentDetailShow===true){
              this.medicalList[0] =this.medicalListData 
              this.medicalList[1] =this.medicalListData 
          }
            console.log(aesFecInfo);
          }
        })
        .catch(res => {
          console.log("医疗机构信息查询(列表)接口数据异常:", res);
        });
    },
    //查询求人案件信息(详情)
    getFindPersonCaseDetailsQuery(jobid) {
      var fecInfo = {
        jobId: jobid
      };
      findPersonCaseDetailsQuery(fecInfo)
        .then(res => {
          console.log("--------查询求人案件信息(详情)接口数据--------");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.jobOfferInfo = aesFecInfo.data[0];
            this.getjobOfferInfoUrl(this.jobOfferInfo.jobPhoto1);
            this.getjobOfferInfoUrl(this.jobOfferInfo.jobPhoto2);
            this.getjobOfferInfoUrl(this.jobOfferInfo.jobPhoto3);
          }
        })
        .catch(res => {
          console.log("查询求人案件信息(详情)接口数据异常:", res);
        });
    },
    //医疗机构信息查询(详情) //id未传
    getMedicalInstitutionDetailsQuery(medicalId) {
      var fecInfo = {
        medicalId: medicalId,
        pageNumber: this.currentPage,
        pageSize: this.pageSize
      };

      medicalInstitutionDetailsQuery(fecInfo)
        .then(res => {
          console.log("--------医疗机构信息查询(详情)接口数据--------");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            this.medicalInstitution = aesFecInfo.data1[0];
            this.getLanguage();
            console.log(aesFecInfo);
            this.tableData = aesFecInfo.data2;
            this.total = this.tableData.length;
            console.log(this.tableData);
            //头像回显
            var fakeInfo = {
              message: this.medicalInstitution.avatarAddress
            };
            getUrlFromOSS(fakeInfo)
              .then(res => {
                console.log("-----------头像回显-----------");
                if (res.data.code === "200 OK") {
                  const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
                  console.log(aesFecInfo);
                  this.avatarAddressUrl = aesFecInfo.message;
                }
                console.log(res);
              })
              .catch(res => {
                console.log("-----------头像回显-----------");
                console.log(res);
              });
          }
        })
        .catch(res => {
          console.log("医疗机构信息查询(详情)接口数据异常:", res);
        });
    }
  }
};
</script>
<style scoped>
::-webkit-scrollbar {display: none; /* Chrome Safari */}
.tooltip-content{
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

}
.top-box-one {
  height: 384px;
  position: absolute;
  top: 0;
  left: 0;
  background: transparent;
  z-index: 10;
}

.top-box-one .search {
  background: transparent;
}

.top-box-two {
  height: 384px;
  position: absolute;
  top: 0;
  left: 0;
  background: transparent;
  z-index: 9;
  width: 100%;
  min-width: 1300px;
}

.index-top {
  height: 64px;
  padding: 16px 35px;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
}

.box-title-small {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #000000;
}

.logo {
  width: 400px;
  display: flex;
}

.logo-title {
  font-family: "Mochiy Pop One";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 35px;
  text-align: center;
  letter-spacing: -0.02em;
  color: #686868;
  margin: 0 5px;
}

.change-lang {
  margin-top: 15px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 13.6333px;
  line-height: 16px;
  align-items: center;
  letter-spacing: 0.639063px;
  color: #686868;
}

.login-and-then {
  flex: 1;
  overflow: hidden;
}

.mask {
  float: right;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: #686868;
  line-height: 32px;
  margin: 0px 4px;
  display: flex;
}

.mask img {
  width: 28px;
  height: 28px;
  text-align: center;
  border-radius: 50%;
  margin-right: 10px;
  overflow: hidden;
}

.top-icon-login {
  float: right;
  line-height: 32px;
}

.top-icon-login img {
  width: 24px;
  cursor: pointer;
  height: 24px;
  margin-right: 20px;
}

.job-posting {
  cursor: pointer;
  float: right;
  width: 100px;
  height: 30px;
  box-sizing: border-box;
  align-items: center;
  background: #51abff;
  border-radius: 4px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  margin-left: 16px;
  cursor: pointer;
}

.search {
  height: 320px;
  background: #51abff;
}

.search-title {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: 320px;
  margin: 0 auto;
  padding: 43px 100px;
  box-sizing: border-box;
  position: relative;
}

.search-title-main {
  margin-top: 70px;
  margin-bottom: 15px;
  font-family: "Mochiy Pop P One";
  font-style: normal;
  font-weight: 400;
  font-size: 56px;
  line-height: 24px;
  color: #e5e5e5;
  height: 70px;
}

.search-main {
  width: 720px;
  height: 80px;
  background: #fafafa;
  border-radius: 8px;
  padding: 20px 16px;
  box-sizing: border-box;
}

.search-input {
  padding: 0 10px;
  width: 560px;
  height: 40px;
  box-sizing: border-box;
  margin-right: 15px;
}

.search /deep/ .el-input__inner {
  width: 560px;
  height: 40px;
  background: #fafafa;
  border: 1px solid #686868;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  font-feature-settings: "salt" on, "liga" off;
  color: #686868;
}

.el-icon-search {
  font-size: 16px;
  font-weight: 600;
  color: #000;
}

.el-icon-location-outline {
  font-size: 18px;
  font-weight: 600;
  color: #000;
}

.search-button {
  height: 40px;
  width: 80px;
  margin-left: 20px;
  box-sizing: border-box;
  background: #fc630c;
  border-radius: 8px;
  font-family: "Roboto";
  font-style: normal;

  font-weight: 400;
  font-size: 16px;
  font-feature-settings: "salt" on, "liga" off;
  color: #ffffff;
  cursor: pointer;
}

.search-img {
  position: absolute;
  bottom: 0;
  z-index: 9;
  left: 800px;
}

.main-information {
  width: 100vw;
  min-width: 1280px;
}

.main-top {
  margin-top: 384px;
  height: 76px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.main-top-button-normal {
  width: 300px;
  height: 40px;
  background: #51abff;
  border-radius: 4px;
  font-family: "Roboto";
  font-style: normal;
  cursor: pointer;
  font-weight: 400;
  font-size: 18px;
  font-feature-settings: "salt" on, "liga" off;
  color: #ffffff;
  margin-left: 40px;
}

.main-top-button-css {
  width: 300px;
  height: 40px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  font-family: "Roboto";
  font-style: normal;
  cursor: pointer;
  font-weight: 400;
  font-size: 18px;
  font-feature-settings: "salt" on, "liga" off;
  color: #51abff;
  margin-left: 40px;
}

.information-main {
  box-sizing: border-box;
  display: flex;
  flex-flow: wrap;
  width: 1100px;
  margin: auto;
}

.inform-box {
  width: 480px;
  height: 360px;
  padding: 20px 30px;
  box-sizing: border-box;
  border: 1px solid #c9cfda;
  box-sizing: border-box;
  border-radius: 8px;
  background: #fff;
  margin: 15px 40px;
  cursor: pointer;
}

.seeking-square {
  width: 550px;
  padding-bottom: 20px;
}

.talent-pool {
  width: 550px;
}

.classification {
  width: 280px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 32px;
  line-height: 32px;
  border-radius: 8px;
  padding-left: 10px;
  box-sizing: border-box;
  background: #e8edf1;
  border-radius: 8px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  text-align: left;
  color: #686868;
}

/*老款*/
/*.box-title {*/
/*  height: 60px;*/
/*  margin-top: 15px;*/
/*  font-family: "Poppins";*/
/*  font-style: normal;*/
/*  font-weight: 500;*/
/*  font-size: 22px;*/
/*  line-height: 30px;*/
/*  color: #000000;*/
/*  padding: 0 5px;*/
/*  box-sizing: border-box;*/
/*  display: -webkit-box;*/
/*  -webkit-box-orient: vertical;*/
/*  -webkit-line-clamp: 2;*/
/*  overflow: hidden;*/
/*  display: flex;*/
/*}*/

.box-title {
  height: 70px;
  line-height: 70px;
  padding: 0 5px;
  box-sizing: border-box;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  color: #000;
  display: flex;
}

.company-name {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #000000;
  margin-top: 4px;
  padding: 0 5px;
  box-sizing: border-box;
}

.box-mini {
  height: 30px;
  padding-top: 4px;
  box-sizing: border-box;
  display: flex;
  margin-top: 5px;
}

.mini-box-main {
  width: 100px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  border: 1px solid rgba(104, 104, 104, 0.8);
  box-sizing: border-box;
  border-radius: 8px;
  margin: 0px 4px;
}

.work-content {
  height: 60px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #686868;
  padding: 0 5px;
  box-sizing: border-box;
  margin-top: 8px;
  box-sizing: border-box;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}

.work-content1 {
  height: 100px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #686868;
  padding: 0 5px;
  box-sizing: border-box;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
  margin-top: 8px;
}

.last-login {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #686868;
  padding: 0 5px;
  box-sizing: border-box;
}

.last-login2 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #686868;
  padding: 0 5px;
  box-sizing: border-box;
  margin-top: 15px;
}

.inform-box {
  width: 480px;
  height: 360px;
  padding: 20px 30px;
  box-sizing: border-box;
  border: 1px solid #c9cfda;
  box-sizing: border-box;
  border-radius: 8px;
  background: #fff;
  margin: 15px 40px;
  cursor: pointer;
}

.seeking-square {
  width: 550px;
}

.talent-pool {
  width: 550px;
}

.classification {
  height: 32px;
  line-height: 32px;
  width: 230px;
  border-radius: 8px;
  padding-left: 10px;
  box-sizing: border-box;
  background: #e8edf1;
  border-radius: 8px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  text-align: left;
  color: #686868;
}

.company-name {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #000000;
  margin-top: 4px;
  padding: 0 5px;
  box-sizing: border-box;
}

.box-mini {
  height: 30px;
  padding-top: 4px;
  box-sizing: border-box;
  display: flex;
  margin-top: 5px;
}
/* 
.work-content {
  height: 65px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #686868;
  padding: 0 5px;
  box-sizing: border-box;
  margin-top: 8px;
  box-sizing: border-box;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
} */

.last-login {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #686868;
  padding: 0 5px;
  box-sizing: border-box;
}

.school-information {
  height: 312px;
  width: 480px;
  border: 1px solid #c9cfda;
  box-sizing: border-box;
  border-radius: 8px 8px 0px 0px;
  margin-top: 15px;
  padding: 20px 30px;
  position: relative;
}

.school-box-top {
  width: 230px;
  height: 32px;
  padding: 6px 8px;
  background: #e8edf1;
  border-radius: 8px;
  box-sizing: border-box;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #686868;
}

.school-box-button {
  margin-top: 20px;
}

.school-box-button button {
  padding: 10px 16px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  text-align: center;
  color: #51abff;
}

.school-box-button .school-box-button1 {
  width: 200px;
  padding: 10px 0;
  background: #51abff;
  border-radius: 8px;
  color: #fff;
}

.back-over {
  position: absolute;
  top: 10px;
  right: 15px;
  cursor: pointer;
}

.recruitment-box-main {
  height: 813px;
  width: 521px;
  border-radius: 8px;
  border: 1px solid #c9cfda;
  box-sizing: border-box;
  border-radius: 8px;
  margin: 15px 0;
  padding: 7px 25px 7px 20px;
  box-sizing: border-box;
  position: relative;
}

.is_fixed {
  top: 0;
  height: 813px;
  width: 521px;
  border-radius: 8px;
  border: 1px solid #da1414;
  box-sizing: border-box;
  border-radius: 8px;
  margin: 15px 0;
  padding: 7px 25px 7px 20px;
  box-sizing: border-box;
  position: fixed;
}

.recruitment-title {
  height: 32px;
  line-height: 32px;
  background: #e8edf1;
  border-radius: 8px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #686868;
  margin-top: 20px;
  padding-left: 10px;
  width: 280px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.recruitment-box-title {
  height: 58px;
  width: 415px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  color: #000000;
  margin-top: 12px;
}

.recruitment-box-button {
  margin-top: 24px;
  padding-left: 20px;
  box-sizing: border-box;
  display: flex;
  height: 40px;
}

.recruitment-box-button .button1 {
  width: 200px;
  height: 40px;
  background: #51abff;
  border-radius: 8px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #ffffff;
  cursor: pointer;
}

.recruitment-box-button .button2 {
  width: 100px;
  height: 40px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #51abff;
  cursor: pointer;
  margin-left: 12px;
}

.mask-recruitment {
  width: 470px;
  height: 480px;
  margin-top: 30px;
  overflow: hidden;
}

.recruitment-main-scroll {
  width: 490px;
  padding-right: 20px;
  box-sizing: border-box;
  height: 480px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.recruitment-scroll-img {
  width: 470px;
  height: 115px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.box-introduce {
  height: 30px;
  display: flex;
  padding-left: 20px;
  box-sizing: border-box;
  justify-content: space-between;
  margin-bottom: 10px;
}

.box-introduce-main {
  background: #fc630c;
  border-radius: 4px;
  padding: 0 10px;
  line-height: 30px;
  text-align: center;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
}

.specific-contents {
  padding-left: 20px;
  padding-bottom: 80px;
  box-sizing: border-box;
}

.specific-main {
  height: 90px;
  display: flex;
  justify-content: space-between;
}

.specific-main-box {
  width: 200px;
}

.specific-main-top {
  width: 200px;
  height: 45px;
  line-height: 45px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  color: #686868;
  border-bottom: 1px solid #686868;
}

.specific-main-top-title {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #686868;
  height: 45px;
  line-height: 45px;
}

.long-box {
  width: 100%;
  height: 130px;
}

.long-box-title {
  width: 100%;
  height: 45px;
  line-height: 45px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  color: #686868;
  border-bottom: 1px solid #686868;
  margin-bottom: 5px;
}

.long-box-main {
  height: 80px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #686868;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  /*显示的行数*/
  overflow: hidden;
}

.disappear-box {
  width: 25px;
  height: 25px;
  position: absolute;
  top: 10px;
  right: 20px;
  cursor: pointer;
}

.detailed-organization {
  width: 500px;
  height: 826px;
  background: #ffffff;
  border: 1px solid #c9cfda;
  box-sizing: border-box;
  border-radius: 4px;
  margin-top: 15px;
  box-sizing: border-box;
  overflow: hidden;
}

.organization-box {
  width: 520px;
height: 826px;
  overflow-y: scroll;
  overflow-x: unset;
  padding: 15px 35px 45px 15px;
  box-sizing: border-box;
  position: relative;
}

.organization-box-img {
  height: 160px;
  display: flex;
  margin-top: 15px;
}

.avatar {
  width: 150px;
  height: 150px;
  border-radius: 50%;
}

.avatar img {
  width: 150px;
  height: 150px;
}

.organization-institution-name {
  flex: 1;
}

.institution-title {
  width: 270px;
  height: 57px;
  line-height: 57px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  /*margin-top: 45px;*/
  margin-left: 25px;
  padding: 0 20px;
  box-sizing: border-box;
  position: relative;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #686868;

}
.institution-title-tootips {
  width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; 
}
.institution-title-main {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  height: 24px;
  line-height: 24px;
  color: #51abff;
  position: absolute;
  background: #fff;
  top: -14px;
  left: 16px;
  
}

.detail-inline {
  height: 45px;
  margin-top: 20px;
  display: flex;
}

.inline-box-one {
  width: 200px;
  height: 44px;
  padding: 0 20px;
  line-height: 44px;
  background: #ffffff;
  border: 2px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
  margin-right: 10px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #686868;
}
.inline-box-one-tooltip {
  width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; 
}
.inline-box-one .ps-span {
  display: inline-block;
  height: 24px;
  line-height: 24px;
  position: absolute;
  top: -12px;
  left: 20px;
  background: #fff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #51abff;
}

.inline-box-two {
  width: 290px;
  height: 44px;
  padding: 0 20px;
  line-height: 44px;
  background: #ffffff;
  border: 2px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #686868;
}
.inline-box-two-tooltip{
  width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; 
}

.inline-box-two .ps-span {
  display: inline-block;
  height: 20px;
  line-height: 20px;
  position: absolute;
  top: -10px;
  left: 20px;
  background: #fff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #51abff;
}

.inline-box-three {
  width: 140px;
  height: 44px;
  padding: 0 20px;
  line-height: 44px;
  background: #ffffff;
  border: 2px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
  /* margin-right: px; */
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #686868;
}

.inline-box-three .ps-span {
  display: inline-block;
  height: 20px;
  line-height: 20px;
  position: absolute;
  top: -10px;
  left: 20px;
  background: #fff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #51abff;
}

.inline-box-dropdown {
  height: 40px;
  line-height: 45px;
  overflow: hidden;
}

.el-dropdown-link {
  width: 130px;
  display: inline-block;
}

.inline-box-dropdown i {
  float: right;
  margin-top: 15px;
  font-weight: 700;
}

.inline-box-dropdown1 {
  height: 40px;
  line-height: 45px;
  overflow: hidden;
}

.inline-box-dropdown1 .el-dropdown-link {
  width: 90px;
}

.inline-box-dropdown1 i {
  float: right;
  margin-top: 15px;
  font-weight: 700;
}

.inline-box-one-margin {
  margin-right: 5px;
}

.inline-box-three-margin {
  margin-right: 5px;
}

.inline-detail-shi {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #51abff;
}

.inline-detail-ye {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #09101d;
}

.detail-inline1 {
  min-height: 45px;
  margin-top: 20px;
}

.inline-table {
  width: 100%;
  min-height: 150px;
  padding-bottom: 130px;
}

.inline-table /deep/ .el-input__inner {
  border: 1px solid transparent;
  padding: 0px;
}

.inline-table /deep/ .el-dropdown {
  height: 28px;
  margin-top: 3px;
  width: 60px;
}

.display-none-css {
  position: absolute;
  top: 15px;
  right: 25px;
  cursor: pointer;
}

.pagination-css {
  height: 30px;
  margin-top: 10px;
  margin-bottom: 50px;
}

.pagination {
  float: right;
}

.issFixed {
  top: -25px;
  margin-left: -15px;
  width: 520px;
  min-height: 826px;
  padding: 15px 35px 15px 15px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: fixed;
}

.inform-box-active {
  width: 480px;
  height: 360px;
  padding: 20px 30px;
  box-sizing: border-box;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  background: #fff;
  margin: 15px 40px;
  cursor: pointer;
}

.search-dialog {
  width: 300px;
  height: 0px;
  position: absolute;
  top: 600px;
  left: 850px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.6);
}

.dialog-main {
  width: 498px;
  height: 200px;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 10px 5px -10px rgba(0, 0, 0, 0.1), 0 0 4px 0 rgba(0, 0, 0, 0.1);
}

.box {
  margin-top: 50px;
  height: 50px;
  line-height: 24px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 24px;
}

.dialog-button {
  margin-top: 30px;
  width: 100px;
  height: 24px;
  line-height: 24px;
  background: #ffffff;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  cursor: pointer;
}

.form-button {
  margin-left: 20px;
  text-align: center;
  display: flex;
}

.form-button button {
  height: 18px;
  /*line-height: 20px;*/
  width: 50px;
  background: #fc630c;
  border-radius: 1px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  color: #ffffff;
}

.form-button2 {
  margin-left: 240px;
  text-align: center;
  display: flex;
  margin-top: 50px;
}

.form-button2 button {
  height: 18px;
  /*line-height: 20px;*/
  width: 50px;
  background: #fc630c;
  border-radius: 1px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  color: #ffffff;
}

.el-icon-loading-icon {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 20px;
  background: #e8edf1;
  line-height: 20px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/educateFront/index.vue